import { Fragment } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    // Support both 'href' (preferred) and 'link' (legacy) for backwards compatibility
    href: PropTypes.string,
    link: PropTypes.string,
  })).isRequired,
  separator: PropTypes.string,
  className: PropTypes.string,
  asNav: PropTypes.bool,
};

/**
 * Renders a list of legal/footer links with flexible layout options.
 *
 * @param {Array} links - Array of link objects with `label` and `href` (or `link` for backwards compatibility)
 * @param {string} separator - Separator between links when not rendered as nav (default: ' | ')
 * @param {string} className - Additional CSS classes
 * @param {boolean} asNav - Render as semantic <nav> element instead of inline <p> (default: false)
 */
function LegalLinks({
  links,
  separator = ' | ',
  className = '',
  asNav = false,
}) {
  if (links.length === 0) return null;

  // Normalize both 'href' and 'link' properties to 'href' for backwards compatibility
  const normalizedLinks = links.map(link => ({
    label: link.label,
    href: link.href || link.link,
  }));

  if (asNav) {
    return (
      <nav className={`footer__nav ${className}`.trim()} aria-label="Footer">
        {normalizedLinks.map((link, idx) => (
          <a
            key={`${link.label}-${idx}`}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label}
          </a>
        ))}
      </nav>
    );
  }

  return (
    <p className={className}>
      {normalizedLinks.map((link, idx) => (
        <Fragment key={`${link.label}-${idx}`}>
          {idx > 0 && separator}
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label}
          </a>
        </Fragment>
      ))}
    </p>
  );
}

LegalLinks.propTypes = propTypes;

export default LegalLinks;

// Copyright © 2025 Micruity Inc.
